import {DomainEvent} from './DomainEvent';
import {ProfilePlayerSeasonBan} from '../resources/ProfilePlayerSeasonBan';

export class ProfileSeasonBanUpdated extends DomainEvent<ProfilePlayerSeasonBan> {}
